export class Destino {
  ativo: boolean;
  id: number;
  observacao: string;
  destino: string;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/destinos/shared/destino.model.ts
 **/